import React, { Component } from 'react';
import { Typography, Row, Col, Radio } from "antd";

import Schedule from "../../containers/Schedule/index.jsx";

import { withRouter, Redirect } from "react-router-dom";

import Core from "../../Core";

import "./index.scss";

const { Title } = Typography;

class SchedulePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
    this.verifyLogin = this.verifyLogin.bind(this);
  }

  componentDidMount() {
    this.verifyLogin();
  }

  verifyLogin() {
    if (!Core.data().login) {
      this.setState({ redirect: true });
    }
  }

  render() {
    const { redirect } = this.state;
    if (redirect) {
      if (Core.data().config.login == true) {
        return <Redirect to="/login" />;
      }
      return <Redirect to="/" />;
    }
    return (
      <div className="schedule-page default-bg">
        <div className="schedule-page__nav">
          <Radio.Group
            options={[
              {
                label: "Program",
                value: "program",
              },
              {
                label: "Event",
                value: "player",
              },
            ]}
            onChange={(val) => this.props.history.push(`/${val.target.value}`)}
            value={"program"}
            optionType="button"
            buttonStyle="solid"
          />
        </div>
        <Row className="schedule-page__row" justify="center" align="middle">
          <Col
            xxl={8}
            xl={8}
            lg={8}
            md={24}
            sm={24}
            xs={24}
            className="schedule-page__row__info"
          >
            <img src="/data/images/logo.png" />
            <Typography.Title className="schedule-page__row__info__title">
              PROGRAM
            </Typography.Title>
            <Typography.Paragraph className="schedule-page__row__info__description">
              Check the program and don't miss a thing!{" "}
            </Typography.Paragraph>
          </Col>
          <Col
            xxl={16}
            xl={16}
            lg={16}
            md={24}
            sm={24}
            xs={24}
            className="schedule-page__row__schedule"
          >
            <Schedule />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(SchedulePage);